/**
 * Shared presentation helpers for the data-driven public forms — the enrolment
 * journey (`routes/enrol.tsx`) and the contact form (`routes/contact.tsx`) both
 * render from the host's field list (admin → Forms), so they must phrase the
 * same field the same way.
 */

/**
 * Placeholder for a `select` field.
 *
 * "Select {label}" only reads well when the label is a noun ("Select year
 * level"). Hosts often phrase a question instead — "How did you hear about
 * us?" — which would give "Select how did you hear about us?". Those get a
 * neutral prompt.
 */
export function selectPlaceholder(label: string): string {
  const trimmed = label.trim();
  return trimmed.endsWith("?") ? "Choose an option" : `Select ${trimmed.toLowerCase()}`;
}

/**
 * Is this `date` question asking when someone was BORN?
 *
 * A birth date is decades away from today, so it gets the Day/Month/Year
 * controls (`DateOfBirthInput`) instead of the browser's calendar, which opens
 * on the current month. Every other date a host might add — "date you last
 * attended", a permission-slip date — is near today, where the calendar is
 * genuinely the quicker tool, so those keep it.
 *
 * Matched on the host's own wording as well as the field name, so a question
 * added later as `child_dob` or "Birth date" gets the right control without
 * anyone having to know this list exists.
 */
export function isBirthDateField(field: { name: string; label: string }): boolean {
  const haystack = `${field.name} ${field.label}`.toLowerCase();
  return haystack.includes("birth") || /\bdob\b/.test(haystack);
}
